export function maskEmail(
  email: string,
  options: { showFirst?: number; showLast?: number; maskChar?: string } = {},
): string {

  const { showFirst = 1, showLast = 1, maskChar = '*' } = options;

  if (!email || typeof email !== 'string') {

    return '';

  }

  const [identifier, domain] = email.split('@');

  if (!identifier || !domain) {

    return '';

  }

  if (identifier.length <= showFirst + showLast) {

    return (
      identifier[0] +
      maskChar.repeat(Math.max(0, identifier.length - 1)) +
      '@' +
      domain
    );
  
  }

  const start = identifier.slice(0, showFirst);
  const end = identifier.slice(-showLast);
  const middle = maskChar.repeat(identifier.length - showFirst - showLast);

  return `${start}${middle}${end}@${domain}`;

}
